import React, { useState, useEffect } from 'react';
import './CTAButton.css';

const messages = [
  {
    title: "🚀 Visites d’affaires en Amérique du Nord!",
    text: "Un tremplin unique pour vos échanges B2B avec les États-Unis & Canada.",
  },
  {
    title: "💻 Multipliez votre visibilité et vos ventes !",
    text: "Création de site web, refonte & SEO ",
  },
  {
    title: "⚙️ Optimisez vos process !",
    text: "Outils numériques performants pour structurer, normaliser et gagner en efficacité.",
  },
  {
    title: "🎯 Boostez votre carrière !",
    text: "Coaching personnalisé, stages et opportunités pour connecter talents malagasy et marché international.",
  }
];

const CTAButton = () => {
  const [showModal, setShowModal] = useState(false);
  const [index, setIndex] = useState(0);
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
  const timeoutId = setTimeout(() => {
    setShowModal(true);
    setAnimate(true);

    // Start interval after first display
    const messageInterval = setInterval(() => {
      setIndex(prev => (prev + 1) % messages.length);
      setAnimate(true);

      setTimeout(() => setAnimate(false), 2500);
      setShowModal(true);
    }, 300000); // Changement de message (5 minutes ici)

    // Cleanup interval when component unmounts
    return () => clearInterval(messageInterval);
  }, 30000); // ⏱️ 30 secondes d'attente avant première apparition

  return () => clearTimeout(timeoutId); // Nettoyage du timeout si le composant se démonte
}, []);


  const handleClose = () => {
    setShowModal(false);
  };

  return (
    <>
      {showModal && (
        <div className="modal-overlay" onClick={handleClose} aria-modal="true" role="dialog" aria-labelledby="modal-title" aria-describedby="modal-desc">
          <div className={`modal-content ${animate ? 'animate' : ''}`} onClick={e => e.stopPropagation()}>
            <button className="modal-close" onClick={handleClose} aria-label="Fermer la fenêtre modale">×</button>
            <h2 id="modal-title">{messages[index].title}</h2>
            <p id="modal-desc">{messages[index].text}</p>
            <button
              className="modal-button"
              onClick={() => window.location.href='/service'}
              aria-label="Découvrir nos services"
            >
              Découvrez nos services →
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default CTAButton;
